import { isInViewport } from './modules/util.js';

// Facebook Pixel Code Start
if (typeof fbq === 'undefined') {
  !(function(f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function() {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js'
  );
  fbq('init', '697927486977350');
}

// Facebook Pixel Code End

$(function() {
  const redeemOfferBanner = $('.sticky-banner');
  const canHideStickyBanner = () => {
    const isBannerSectionVisible = isInViewport('#banner-ca-freebie');
    const isXperienceSectionVisible = isInViewport('.screen_9');
    const isFooterSectionVisible = isInViewport('footer');
    return (
      isBannerSectionVisible ||
      isXperienceSectionVisible ||
      isFooterSectionVisible
    );
  };
  $(document).on('scroll', e => {
    if (canHideStickyBanner()) {
      redeemOfferBanner.addClass('hide');
    } else {
      redeemOfferBanner.removeClass('hide');
    }
  });

  $('.fbPixelTrack').on('click', e => {
    fbq('trackCustom', 'CA_freebie_signup');
  });
});

(function() {
  var qs,
    js,
    q,
    s,
    d = document,
    gi = d.getElementById,
    ce = d.createElement,
    gt = d.getElementsByTagName,
    id = 'typef_orm_share',
    b = 'https://embed.typeform.com/';
  if (!gi.call(d, id)) {
    js = ce.call(d, 'script');
    js.id = id;
    js.src = b + 'embed.js';
    q = gt.call(d, 'script')[0];
    q.parentNode.insertBefore(js, q);
  }
})();
